import {useEffect} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";
import OccurrencesDetailsService from "../../../../../../services/reports/occurrences-details-service.js";

export default function TableContent({ data }) {
    const tableContent = data?.TableMode ?? [];

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "Detalhamento de ocorrências", "table-content",);
    }, [tableContent]);

    return (
        <>
            <table id="table-content" className="table report-table mt-3" sheet-name="Detalhamento de ocorrências com indivíduo">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className="w-9%">ID Ocorrência</th>
                        <th className="w-9%">Natureza</th>
                        <th className="w-9%">D/H do fato</th>
                        <th className="w-9%">Dia da semana</th>
                        <th className="w-9%">Bairro</th>
                        <th className="w-9%">Condição</th>
                        <th className="w-9%">Nome</th>
                        <th className="w-9%">Nacionalidade</th>
                        <th className="w-9%">Idade</th>
                        <th className="w-9%">Recorrente</th>
                        <th className="w-9%">Apresentado por</th>
                    </tr>
                </thead>
                <tbody className="bg-white">
                {tableContent.map((element, index) => {
                    const notInfo = <span className="text-[#8F8F8F] italic">Não informado</span>;
                    return (
                        <tr key={index}>
                            <td>
                                <button
                                    type="button"
                                    onClick={() => OccurrencesDetailsService.openSentryView(element.id)}
                                    className="text-[#1588F3] text-start underline cursor-pointer print:text-black print:no-underline!"
                                >
                                    {element.id ?? "Não informado"}
                                </button>
                            </td>
                            <td>{element.reason ?? notInfo}</td>
                            <td>{element.date ?? notInfo}</td>
                            <td>{element.week_day ?? notInfo}</td>
                            <td>{element.neighborhood ?? notInfo}</td>
                            <td>{element.condit ?? notInfo}</td>
                            <td>{element.name ?? notInfo}</td>
                            <td>{element.nat ?? notInfo}</td>
                            <td>{element.age ?? "-"}</td>
                            <td>{element.recurrent ?? notInfo}</td>
                            <td>{element.presented ?? notInfo}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>

            <div className="chart-divisor"/>
        </>
    )
}
